import { CLIP_UPDATE_TYPE } from './constants';
import { updateClipDataWithSplits } from './updateWithSplits';
import { Clip } from '@/domains/asset';

export const createHookSegment = ({
  startTime,
  endTime,
  startSegmentId,
  endSegmentId,
  clipData,
  clipId
}: {
  startTime: number;
  endTime: number;
  startSegmentId: string;
  endSegmentId: string;
  clipData: Clip;
  clipId: string;
}): boolean => {
  if (startSegmentId !== endSegmentId) {
    return false;
  }

  try {
    updateClipDataWithSplits(
      {
        clipId,
        actionType: CLIP_UPDATE_TYPE.CREATE_HOOK,
        startTime,
        endTime,
        segmentId: startSegmentId
      },
      { currentClipData: clipData }
    );
    return true;
  } catch (error) {
    window.logger?.error('Failed to create hook segment', error);
    return false;
  }
};
